import { render } from "./SavedReportsList.vue?vue&type=template&id=5b0d33fc&scoped=true"
import script from "./SavedReportsList.vue?vue&type=script&lang=js"
export * from "./SavedReportsList.vue?vue&type=script&lang=js"

import "./SavedReportsList.vue?vue&type=style&index=0&id=5b0d33fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0d33fc"]])

export default __exports__